<div class="country-information">
	@if ((item.type !== 'CategoryItemConfig' && item.itemDetail.value) || item.type == 'CategoryItemConfig') {
	<div class="content-wrapper content-depth--{{depth}} m-3">
		<p class="mb-1 pt-1 pb-1">
			@if (item?.children.length > 0) {
			<i class="fa mr-2"
			   (click)="toggleItem()"
			   [ngClass]="{'fa-angle-down mr-1': itemVisible, 'fa-angle-right mr-2': !itemVisible}"
			   style="margin-left: -1.25em" role="button">
			</i>
			}
			<span [class]="headingClasses">{{ item.name }}</span>
		</p>
		@if (item?.itemDetail.value && itemVisible) {
		<div [innerHTML]="item?.itemDetail.value" class="user-content"></div>
		}
		<ng-container *featureToggle="features.AuditHistory">
			@if (item?.itemDetail.hasHistory) {
			<a href="javascript:void(0)" (click)="onShowHistory()" class="small ml-1">View archive</a>
			}
		</ng-container>
		@if (item?.itemDetail.hasHistory && (item?.itemDetail.value && itemVisible && item?.itemDetail.metaData.length > 0)) {
		<span> | </span>
		}
		@if (item?.itemDetail.value && itemVisible && item?.itemDetail.metaData.length > 0) {
		<a href="javascript:void(0)" (click)="onShowSources()" class="small ml-1">View sources</a>
		}
		@if (itemVisible && item?.children.length > 0) {
		<div class="mb-5 mt-3">
			@for (child of item.children; track child) {
			<country-content [item]="child" [depth]="depth+1" [countryCode]="countryCode">
			</country-content>
			}
		</div>
		}
	</div>
	}

	<history-modal #historyModal id="historyModal" [title]="item.name" [itemConfigId]="item.id" [countryCode]="countryCode"></history-modal>
	<metadata-modal #metadataModal id="metadataModal" [metadatas]="item?.itemDetail.metaData"></metadata-modal>
</div>